import { Box } from 'components/Box';
import { ObservationCycle } from 'types/api/envScales/ObservationCycle';
import { Assessment } from 'types/api/envScales/Assessment';
import { AgeLevel } from 'types/api/envScales/AgeLevel';
import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';
import MetaDataRating from '../MetaDataMultiSelect/MetaDataRating';

interface ITSecondEditionMetaDataContentProps {
  /** Observation Cycle. */
  cycle: ObservationCycle;

  /** CLASS Assessment. */
  assessment: Assessment;

  /** Environmental Scales Age Level. */
  ageLevel: AgeLevel;

  /** Observation ID */
  observationId: number;

  /** Meta data values */
  values: CycleMetaDataValue[];
}

/**
 * Renders metadata content specific to Infant Toddler (IT) Second Edition assessments
 */
function ITSecondEditionMetaDataContent({
  cycle,
  ageLevel,
  observationId,
  values
}: ITSecondEditionMetaDataContentProps) {
  const categoriesClassSecondEdition = ageLevel.meta_data_categories
    .filter(category => category.assessment_template.class_version === 2)
    .filter(category => category.choices.length > 0);

  return (
    <Box mt="50px">
      <MetaDataRating
        observationId={observationId}
        cycle={cycle}
        categories={categoriesClassSecondEdition}
        values={values}
      />
    </Box>
  );
}

export default ITSecondEditionMetaDataContent;
